import clsx from 'clsx';

import { core } from '@tock/coretypes';
import { getIconForType } from 'utils/importantDateUtils';

interface Props {
  type: core.PatronProfile.DayType;
  className?: string;
}

const ImportantDateIcon = ({ type, className }: Props) => {
  return (
    <div>
      <div className={clsx('ImportantDate-icon', className)}>{getIconForType(type)}</div>
    </div>
  );
};

export default ImportantDateIcon;
